import { handleImageUrl } from '$/utils/image';

type CanvasImageCacheVariant = 'clean' | 'watermark';

const TEAM_FLOW_CACHE_VARIANT_PARAM = 'tfvariant';

type CanvasCacheParam = 'tfcache' | typeof TEAM_FLOW_CACHE_VARIANT_PARAM;

/** 原样保留云处理查询串，仅新增或更新 Team Flow 自有的缓存参数。 */
function upsertCanvasCacheParam(url: string, name: CanvasCacheParam, value: string): string {
  const hashIndex = url.indexOf('#');
  const urlWithoutHash = hashIndex >= 0 ? url.slice(0, hashIndex) : url;
  const hash = hashIndex >= 0 ? url.slice(hashIndex) : '';
  const encodedValue = encodeURIComponent(value);
  const existingParamPattern = new RegExp(`([?&])${name}=[^&#]*`);

  if (existingParamPattern.test(urlWithoutHash)) {
    return `${urlWithoutHash.replace(existingParamPattern, `$1${name}=${encodedValue}`)}${hash}`;
  }

  let separator = '?';
  if (urlWithoutHash.includes('?')) {
    separator = /[?&]$/.test(urlWithoutHash) ? '' : '&';
  }
  return `${urlWithoutHash}${separator}${name}=${encodedValue}${hash}`;
}

/** 给 Team Flow 节点媒体 URL 添加 SW 缓存标记；variant 用于区分同 path 的水印/无水印缓存。 */
export function markCanvasCacheableUrl(url: string, variant?: CanvasImageCacheVariant): string {
  if (!url || !/^https?:\/\//.test(url)) return url;
  try {
    // URL 构造仅用于校验，不能重新序列化七牛这类无等号的云处理查询参数。
    const parsedUrl = new URL(url);
    if (!parsedUrl.hostname) return url;
    let cacheableUrl = upsertCanvasCacheParam(url, 'tfcache', '1');
    if (variant) {
      cacheableUrl = upsertCanvasCacheParam(cacheableUrl, TEAM_FLOW_CACHE_VARIANT_PARAM, variant);
    }
    return cacheableUrl;
  } catch {
    return url;
  }
}

/** 以 WebP 格式作为 Team Flow 画布图片的展示和缓存源。 */
export function getCanvasImageUrl(url: string, showWatermark?: boolean): string {
  if (!url) return url;

  return markCanvasCacheableUrl(
    handleImageUrl(url, { showWatermark }),
    showWatermark ? 'watermark' : 'clean',
  );
}
